class Animate {
  static set(t) {
    $(t).data('animated', true);
  }
  static check(t) {
    return $(t).data('animated');
  }
  static effects() {
    var k = $(document).scrollTop() + $(window).height() / 2;

    var item = '.section-problems',
        animate_items = ".section-problems .item";
    if (!Animate.check(item))
      $(animate_items).addClass('hidden-for-animate');
    if (k >= $(item).offset().top-50 && !Animate.check(item)) {
      Animate.set(item);
      $(animate_items).each(function(a) {
        var self = this;
        (function() {
          setTimeout(() => {
            $(self)
              .removeClass('hidden-for-animate')
              .addClass('animated zoomIn');
          },250*a);
        })(a);
      });
    }

    var item = '.section-nearby',
        animate_items = ".section-nearby .screen";
    if (!Animate.check(item))
      $(animate_items).addClass('hidden-for-animate');
    if (k >= $(item).offset().top && !Animate.check(item)) {
      Animate.set(item);
      $(animate_items).removeClass('hidden-for-animate').addClass('animated bounceInUp');
    }

    var item = '.section-know',
        animate_items = ".section-know .admin";
    if (!Animate.check(item))
      $(animate_items).addClass('hidden-for-animate');
    if (k >= $(item).offset().top && !Animate.check(item)) {
      Animate.set(item);
      $(animate_items).removeClass('hidden-for-animate').addClass('animated zoomIn');
    }

    var item = '.section-about',
        animate_items = ".section-about li";
    if (!Animate.check(item))
      $(animate_items).addClass('hidden-for-animate');
    if (k >= $(item).offset().top-50 && !Animate.check(item)) {
      Animate.set(item);
      $(animate_items).each(function(a) {
        var self = this;
        (function() {
          setTimeout(() => {
            $(self)
              .removeClass('hidden-for-animate')
              .addClass('animated zoomIn');
          },250*a);
        })(a);
      });
    }

  }


  static parallax() {
    // ***************************************************************************
    // Parallax
    // ***************************************************************************
    var k = $(document).scrollTop(),
        wh = $(window).height();
    var numb = 0;
    $('.parallax').each(function() {
      var top = $(this).offset().top;
      if (k < $(this).offset().top - wh/2) return true;
      $(this).find('img').each(function() {
        if ($(this).offset().top < k-300) return true;
        var t = (k - top) * $(this).data('speed-y')*1,
            x = (k - top) * $(this).data('speed-x')*1,
            maxX = $(this).data('max-x')*1 || 10000,
            maxY = $(this).data('max-y')*1 || 10000,
            minX = $(this).data('min-x')*1 || -10000,
            minY = $(this).data('min-y')*1 || -10000;

        numb++;

        if (x > maxX)
          x = maxX;

        if (t > maxY)
          t = maxY;

        if (x < minX)
          x = minX;

        if (t < minY)
          t = minY;

        $(this).css('transform', 'translate('+x+'px,'+t+'px)');
      });
    });
    
  }
  static init() {
    $('.parallax').animate({ opacity: 1 }, 350);
    $(window).load(function() {
      Animate.effects();
      $(window).scroll( $.throttle( 100, () => { Animate.effects() } ));
      $(window).scroll( $.throttle( 10, function() { Animate.parallax() } ));
    })
  }
}

$(function() {
  Animate.init();
});
